import React, { useState } from 'react'
import className from 'classnames/bind'

import MyhouseAttachmentTooltip from '../MyhouseAttachmentTooltip'
import MyhousePhotoTooltip from '../MyhousePhotoTooltip'

import style from './MyhouseAuthManagementFee.module.scss'

import BlindContent from '@Components/atoms/BlindContent'
import PngMyhouseAuthManagementGuide from '@Ui/images/myhouse/myhouse_auth_management--guide.png'
import { handleNclickMix } from '@Helpers/nclick'
import { NCLICK } from '@Root/contants/lcs'

const cx = className.bind(style)

type Props = {
  onTakePictureChange: any
}

const MyhouseAuthManagementFee: React.FC<Props> = ({ onTakePictureChange }: Props) => {
  const [isShowAttachmentTooltip, setIsShowAttachmentTooltip] = useState(false)
  const [isShowPhotoTooltip, setIsShowPhotoTooltip] = useState(false)

  return (
    <section id="content" className={cx('article')} role="main">
      <BlindContent />
      <div className={cx('inner')}>
        <h3 className={cx('title')}>관리비 고지서 촬영 방법</h3>
        <div
          role="img"
          style={{
            background: `url(${PngMyhouseAuthManagementGuide}) no-repeat`,
            backgroundSize: '295px 306px',
            width: '295px',
            height: '306px',
          }}
          className={cx('image_guide')}
        ></div>
        <strong className={cx('guide')}>
          관리비 고지서에서 우리집 동호수가
          <br /> 잘 보이게 촬영해 주세요.
        </strong>
        <p className={cx('text')}>
          주소지 정보는 입주민 확인 절차에서 사용되며
          <br />
          인증 완료 또는 실패로부터 7일 이후 폐기합니다.
        </p>
        <div className={cx('guideline')}>
          <button
            type="button"
            className={cx('button_guideline')}
            onClick={handleNclickMix(NCLICK.MY_HOUSE.AUTHENTICATION.RESIDENT_FEE.GUIDE, () => setIsShowAttachmentTooltip(true))}
          >
            파일첨부 가이드라인
          </button>
          을 확인해주세요.
        </div>
        <MyhouseAttachmentTooltip isShow={isShowAttachmentTooltip} setIsShow={setIsShowAttachmentTooltip} isCenter />
      </div>
      <button type="button" className={cx('button_photo')} onClick={() => setIsShowPhotoTooltip(true)}>
        촬영 시작하기
      </button>
      <MyhousePhotoTooltip isShow={isShowPhotoTooltip} setIsShow={setIsShowPhotoTooltip} onTakePictureChange={onTakePictureChange} />
    </section>
  )
}

export default MyhouseAuthManagementFee
